import "./portfolioStyling.css";
import { PortfolioImgTile } from "./components/PortfolioImgTile";
import { PageNameText } from "../../molecules/PageNameText.tsx";

export interface DataInterface {
  img: string;
  name: string;
  folderName: string; // todo: remove later
  folderURL: string;
  imgFormat: string;
  imgFormatFull?: string;
  photoShootDate: string;
  index: number;
}

export const PORTFOLIO_ADDED_ALBUMS = {
  "2025-Vasaris": {
    img: "/photos/gallery/2025/Vasaris/main.jpg",
    name: "2025 February",
    folderName: "2025/Vasaris",
    folderURL: "/photos/gallery/2025/Vasaris",
    index: 13,
    imgFormat: "jpg",
    photoShootDate: "2025-02-01"
  },
  "2025-Sausis": {
    img: "/photos/gallery/2025/Sausis/main.jpg",
    name: "2025 January",
    folderName: "2025/Sausis",
    folderURL: "/photos/gallery/2025/Sausis",
    index: 23,
    imgFormat: "jpg",
    imgFormatFull: "jpeg",
    photoShootDate: "2025-01-01"
  },
  "B&W": {
    img: "/photos/gallery/2024/B&W/main.jpg",
    name: "B&W",
    folderName: "2024/B&W",
    folderURL: "/photos/gallery/2024/B&W",
    index: 14,
    imgFormat: "jpg",
    photoShootDate: "2025-01-01"
  },
  Fantasy: {
    img: "/photos/gallery/2024/Fantasy/main.jpg",
    name: "Fantasy",
    folderName: "2024/Fantasy",
    folderURL: "/photos/gallery/2024/Fantasy",
    index: 10,
    imgFormat: "jpg",
    photoShootDate: "2024-06-01"
  },
  Street: {
    img: "/photos/gallery/2024/Street/main.jpg",
    name: "Street",
    folderName: "2024/Street",
    folderURL: "/photos/gallery/2024/Street",
    index: 15,
    imgFormat: "jpg",
    photoShootDate: "2024-06-01"
  },
  Studio: {
    img: "/photos/gallery/2024/Studio/main.jpg",
    name: "Studio",
    folderName: "2024/Studio",
    folderURL: "/photos/gallery/2024/Studio",
    index: 24,
    imgFormat: "jpg",
    photoShootDate: "2024-06-01"
  }
};

export const Portfolio = () => {
  return (
    <div className="flex flex-col bg-black pb-20 pt-5 text-white">
      <PageNameText text="Gallery" />
      <div className="flex w-full flex-wrap items-center">
        {Object.keys(PORTFOLIO_ADDED_ALBUMS).map(
          (key: keyof typeof PORTFOLIO_ADDED_ALBUMS, index) => (
            <PortfolioImgTile
              key={`${index}`}
              index={index}
              name={PORTFOLIO_ADDED_ALBUMS[key].name}
              img={PORTFOLIO_ADDED_ALBUMS[key].img}
              navigateTo={`/portfolio/${key}`}
            />
          )
        )}
      </div>
    </div>
  );
};
